import { useState } from 'react';

/**
 * Custom hook to validate a password.
 * @returns [isValid, setPassword]
 */
export function usePasswordValidator(): [boolean, (password: string) => void] {
  const [password, setPassword] = useState('');
  const hasLength = password.length >= 8;
  return [hasLength, setPassword];
}
